import React, { memo } from 'react';
import { GetHandleProps, SliderItem } from 'react-compound-slider';

interface IProps {
  handle: SliderItem;
  getHandleProps?: GetHandleProps;
}

const Handle = ({ handle: { id, value, percent }, getHandleProps }: IProps) => {
  const handleId = id as any;
  const $style: any = {
    left: `${percent}%`,
    position: 'absolute',
    marginLeft: -8,
    marginTop: -7,
    zIndex: 2,
    width: 16,
    height: 16,
    border: '1px solid #000',
    cursor: 'pointer',
    borderRadius: '50%',
    backgroundColor: '#000',
  };

  return getHandleProps ? (
    <div
      className="handle"
      style={{ ...$style }}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      {...getHandleProps(handleId)}
    />
  ) : (
    <div className="handle" style={{ ...$style }} />
  );
};

export default memo(Handle);
